import { Link, createFileRoute } from "@tanstack/react-router";
import { Trans } from "@lingui/react/macro";

import InfoPageShell from "../components/InfoPageShell";
import LandingLayout from "../components/LandingLayout";

export const Route = createFileRoute("/help")({
  component: HelpPage,
  head: () => ({
    meta: [
      {
        title: "BodaWeb — Ayuda",
      },
    ],
  }),
});

function HelpPage() {
  return (
    <LandingLayout showFooter>
      <InfoPageShell
        eyebrow={<Trans>Ayuda</Trans>}
        intro={
          <Trans>
            Resolvemos lo esencial para que entiendas cómo funciona BodaWeb,
            cuándo iniciar sesión y dónde escribirnos si necesitas una mano más
            cercana.
          </Trans>
        }
        title={<Trans>Ayuda y soporte</Trans>}
      >
        <section className="border-t border-[var(--color-border)] pt-8 first:border-t-0 first:pt-0">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Cómo funciona BodaWeb</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                El flujo empieza en la colección de plantillas. Desde ahí puedes
                elegir un estilo, completar los datos de la boda y crear una
                invitación lista para compartir.
              </Trans>
            </p>
            <p>
              <Trans>
                Si todavía no tienes cuenta, puedes avanzar por el constructor y
                crearla cuando llegue el momento de guardar tu sitio.
              </Trans>
            </p>
          </div>
        </section>

        <section className="border-t border-[var(--color-border)] pt-8">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Cuenta y acceso</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                Si ya tienes una cuenta, puedes{" "}
                <Link
                  className="app-link cursor-pointer"
                  search={{
                    entry: undefined,
                    flow: undefined,
                    template: undefined,
                  }}
                  to="/auth/signin"
                >
                  iniciar sesión
                </Link>{" "}
                y volver a tu panel para editar contenido, revisar las
                confirmaciones de asistencia y abrir tu invitación pública.
              </Trans>
            </p>
            <p>
              <Trans>
                Cada cuenta mantiene un solo sitio activo, así que si vuelves a
                entrar con una invitación ya creada te llevaremos directamente a
                tu panel.
              </Trans>
            </p>
          </div>
        </section>

        <section className="border-t border-[var(--color-border)] pt-8">
          <h2 className="font-display text-3xl leading-none text-[var(--color-ink)]">
            <Trans>Soporte personalizado</Trans>
          </h2>
          <div className="mt-4 space-y-4 text-sm leading-7 text-[var(--color-muted)] sm:text-base">
            <p>
              <Trans>
                Para ayuda general o dudas sobre tu cuenta, escríbenos a{" "}
                <a
                  className="app-link cursor-pointer"
                  href="mailto:soporte@bodaweb.site"
                >
                  soporte@bodaweb.site
                </a>
                .
              </Trans>
            </p>
            <p>
              <Trans>
                Si quieres un diseño más a medida para tu boda, también podemos
                orientarte por ese mismo canal.
              </Trans>
            </p>
          </div>
        </section>
      </InfoPageShell>
    </LandingLayout>
  );
}
